import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		transClientId: Yup.string(),
		transClientSecret: Yup.string(),
		transApiKey: Yup.string(),
		transAuthType: Yup.string(),
	});
};
